import { RefreshCw } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import { m } from '@/lib/paraglide/messages'

interface BaseProps {
    onClick: () => void
    loading?: boolean
    variant?: 'outline' | 'ghost'
    className?: string
}

/**
 * `iconOnly` tự chốt kích thước nút (ô vuông vừa vùng chạm), nên nó và `size`
 * loại trừ nhau — khai báo kiểu ở đây để TypeScript chặn ngay lúc gọi, thay vì
 * âm thầm bỏ qua `size` lúc chạy.
 */
type Props = BaseProps &
    (
        | {
              /**
               * Chỉ hiện icon, giấu chữ "Làm mới" — dùng khi nút phải chen vào
               * một hàng hẹp (thanh lọc trên mobile). Tên nút vẫn còn ở
               * `aria-label`/`title` nên screen reader và tooltip đọc y như bản
               * có chữ.
               */
              iconOnly: true
              size?: never
          }
        | { iconOnly?: false; size?: 'sm' | 'default' }
    )

/** Nút "Làm mới" dùng cho mọi bảng. Convention dự án: bảng nào cũng phải có
 *  để user chủ động refresh data thay vì chờ stale-time. */
export function RefreshButton({
    onClick,
    loading,
    size = 'sm',
    variant = 'outline',
    className,
    iconOnly,
}: Props) {
    return (
        <Button
            size={iconOnly ? 'icon' : size}
            variant={variant}
            disabled={loading}
            onClick={onClick}
            className={className}
            title={m.common_refresh()}
            aria-label={iconOnly ? m.common_refresh() : undefined}
        >
            <RefreshCw
                className={cn(
                    'size-4',
                    !iconOnly && 'mr-1',
                    loading && 'animate-spin',
                )}
            />
            {iconOnly ? null : m.common_refresh()}
        </Button>
    )
}
